<template>
	<div class="project-task-board">
		<AppLazyLoaderComponentFromMonolith
			:params="params"
			:container="Monolith.LAZY_CONTAINER.PROJECT_TASK_BOARD"
		/>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { useProjectDetailsViewStore } from '@/features/Project';
import { type Project } from '@/generated/graphql';

const props = defineProps<{
	projectId: Project['id'];
	retainerPeriodId: number | undefined;
}>();

const projectDetailsViewStore = useProjectDetailsViewStore();

const params = computed(() => ({
	retainerPeriodId: String(props.retainerPeriodId ?? 0),
	taskBoardFilters: projectDetailsViewStore.projectTabsTaskBoardFilters,
}));
</script>

<style lang="scss">
.project-task-board {
	.project-task-set-row,
	.list-block-header .contentBlockHeader {
		max-width: var(--project-page-max-width);
		margin-left: auto;
		margin-right: auto;
	}

	.pipeline-row-wrapper {
		&--lists {
			background: $neutral-10;

			.statusWrapper {
				display: flex;
			}
		}
	}

	.project-task-set-row {
		padding: 0 var(--project-page-side-spacing);

		.taskset-selection-container {
			border-top-left-radius: 1rem;
			border-top-right-radius: 1rem;
		}
	}

	.pipeline-wrapper {
		background: $neutral-10;
		padding: 0 var(--project-page-side-spacing);
	}

	#pipeline-header-row {
		.statusWrapper {
			&:first-child {
				border-bottom-left-radius: 1rem;
			}

			&:last-child {
				border-bottom-right-radius: 1rem;
			}
		}
	}

	.status {
		min-height: 40vh;
	}

	.list-block-header.list-block-header {
		.contentBlockHeader {
			border-bottom: none;
			padding: var(--project-tab-header-padding)
				var(--project-page-side-spacing);
		}
	}

	.statusWrapper {
		.entity {
			border-left: solid 0.375rem $neutral-30;
			padding-left: 1.5rem;

			&.task-is-completed {
				opacity: 0.5;
			}
		}
	}

	.deadline-hover-wrapper {
		font-weight: normal;
	}
}
</style>
